import { getCookieVal } from "@/tool/index";

const createWebSocket = () => {
    let wsInstance = null;
    let reconnectTimer = null;
    let heartbeatTimer = null;
    let forcedClose = false;

    const getSocket = (callback) => {
        if (!wsInstance) {
            const token = getCookieVal("iyuanwu_token");
            wsInstance = new WebSocket(process.env.VUE_APP_WEBSOCKET);

            wsInstance.onopen = (e) => {
                wsInstance.send(JSON.stringify({ token, op: 2 }));
                startHeartbeat();
            };

            wsInstance.onerror = (e) => {
                console.log("数据传输发生错误", e);
            };

            wsInstance.onmessage = (e) => {
                callback(JSON.parse(e.data));
            };

            wsInstance.onclose = () => {
                stopHeartbeat();
                if (!forcedClose) {
                    reconnect();
                }
            };
        }
        return wsInstance;
    };

    const startHeartbeat = () => {
        stopHeartbeat();
        heartbeatTimer = setInterval(() => {
            if (wsInstance && wsInstance.readyState === WebSocket.OPEN) {
                wsInstance.send(JSON.stringify({ op: 14 }));
            }
        }, 60000);
    };

    const reconnect = () => {
        if (reconnectTimer) {
            return;
        }
        reconnectTimer = setTimeout(() => {
            getSocket();
            reconnectTimer = null;
        }, 30000);
    };

    const stopHeartbeat = () => {
        if (heartbeatTimer) {
            clearInterval(heartbeatTimer);
            heartbeatTimer = null;
        }
    };

    return {
        getSocket,
        startHeartbeat,
        reconnect,
        stopHeartbeat,
    };
};

export default createWebSocket;